import { createLogger } from "utils/logging";
import { benefitBounce } from "@otto-ec/nexus-registry/benefit/bounce";
import { defineEvent } from "@otto-ec/global-resources/nexus";
import { BenefitElement, defineElement, buildSearchParams, callBackend } from "../benefit_base";

const ATTRIBUTE_NAMES = {
	VARIATION_ID: "variation-id",
	FEATURE: "feature",
	TEAM: "team",
};

const log = createLogger("tag", "bounce.component");
const BOUNCE_ELEMENT_NAME = "ft9-bounce-v1";

const REQUEST_INITIATOR_FILE_NAME = new URL(import.meta.url).pathname.split("/").pop() ?? "unknown";

const ERROR_KEY = "ft9-benefit-tag-bounce-not-ok";
const ERROR_LABELS = { service: "tag", module: "bounce", team: "ft9" };

if (!benefitBounce.isReady) {
	benefitBounce.assignNamespace({
		init: defineEvent(),
	});
}

export class BounceElement extends BenefitElement {
	protected async hydrate(): Promise<void> {
		this.replaceChildren();

		const params = { variationId: this.getAttribute(ATTRIBUTE_NAMES.VARIATION_ID) };
		const searchParams = buildSearchParams(params);
		log.info("Calling bounce for %s with %s", this.id || "id-not-set", searchParams.toString());

		try {
			const url = new URL(`/benefit-tag/bounce?${searchParams}`, globalThis.location.origin);
			const options = {
				url,
				feature: this.getAttribute(ATTRIBUTE_NAMES.FEATURE),
				team: this.getAttribute(ATTRIBUTE_NAMES.TEAM),
				initiator: REQUEST_INITIATOR_FILE_NAME,
				priority: "high" as const,
				logging: {
					logger: log,
					errorKey: ERROR_KEY,
					errorLabels: ERROR_LABELS,
				},
			};
			const response = await callBackend(options);
			this.innerHTML = await response.text();
			benefitBounce.init.emit({}, { retain: true });
		} catch {
			/*                                                                    */
			/*                                                                          */
		}
	}
}

defineElement(BounceElement, BOUNCE_ELEMENT_NAME, "ftnine_emergency_custom_element_disable_bounce");
